module.exports = __webpack_public_path__ + "img/lock.8696e80e.svg";